require('./openYoungDashboardInfo.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const Avatar = require('components/avatar/avatar');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

class OpenYoungDashboardInfo extends React.Component {
    constructor(props) {
        super(props);
        this.getAvatarSection = this.getAvatarSection.bind(this);
        this.getSecondImgContent = this.getSecondImgContent.bind(this);
        this.handleRedirectClick = this.handleRedirectClick.bind(this);
    }

    componentDidMount() {
        const { immOpenYoungDashboard, getChildList } = this.props;
        if (!immOpenYoungDashboard.get('childListSuccess')) {
            getChildList();
        }
    }

    getSecondImgContent(immChildList) {
        let secondImgContent;
        if (immChildList.size > 2) {
            const avatarCount = immChildList.size - 1;
            secondImgContent = (
                <div className="open-young-dashboard-info__avatar-count">+{avatarCount}</div>
            );
        } else {
            secondImgContent = (
                <Avatar
                    id="childAvatar_1"
                    imgDescription={immChildList.getIn([1, 'childName']).trim()}
                    imgType="info-mode"
                    imgUrl={immChildList.getIn([1, 'image'])}
                />
            );
        }
        return (
            <div
                className="open-young-dashboard-info__avatar-content open-young-dashboard-info__avatar-content--overlap"
                id="oy-avatar-content"
                key="childAvatar_1"
            >
                {secondImgContent}
            </div>
        );
    }

    getAvatarSection(immChildList) {
        const childLength = immChildList.size > 1;
        return (
            <div className="open-young-dashboard-info__avatar-view">
                <div className="open-young-dashboard-info__avatar-content"
                    id="oy-avatar-content"
                    key="childAvatar_0"
                >
                    <Avatar
                        id="childAvatar_0"
                        imgDescription={immChildList.getIn([0, 'childName']).trim()}
                        imgType="info-mode"
                        imgUrl={immChildList.getIn([0, 'image'])}
                    />
                </div>
                {!!childLength && this.getSecondImgContent(immChildList)}
            </div>
        );
    }

    handleRedirectClick() {
        const openYoungDashboardUrl = '/myprofile/open-young-dashboard';
        this.props.history.push(openYoungDashboardUrl);
    }

    render() {
        const { immOpenYoungDashboard } = this.props;
        let dashboardInfo = null;

        if (immOpenYoungDashboard.get('isFetchingChildList')) {
            dashboardInfo = (<LoadingSection />);
        } else if (immOpenYoungDashboard.get('childListSuccess') && immOpenYoungDashboard.get('openYoungChildList').size > 0) {
            dashboardInfo = (
                <div className="open-young-dashboard-info" onClick={this.handleRedirectClick}>
                    {this.getAvatarSection(immOpenYoungDashboard.get('openYoungChildList'))}
                    <div className="open-young-dashboard-info__title">
                        <FormattedText value="openYoungDashboardView-openYoungDashboardView_accessPointTitle" />
                        <div className="open-young-dashboard-info__link">
                            <i className="open-young-dashboard-info__link-icon icon-siguiente" />
                        </div>
                    </div>
                </div>
            );
        }
        return dashboardInfo;
    }
}

OpenYoungDashboardInfo.propTypes = {
    getChildList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immOpenYoungDashboard: PropTypes.object.isRequired,
}

module.exports = withRouter(OpenYoungDashboardInfo);
